import { useEffect, useState } from 'react';
import { httpsCallable } from '../../lib/callable';
import { functions } from '../../firebase';
import { CALLABLE_TIMEOUTS, CLOUD_FUNCTIONS } from '../../constants/firebase';
import type { FreshnessNotices } from './documentFreshness';

/**
 * Every generated document's freshness notice, fetched again whenever
 * `refreshKey` changes (freshnessRefreshKey of the card's documents). A notice
 * that cannot be read is not shown; the Word file still carries it.
 */
export function useDocumentFreshness(projectId: string | undefined, refreshKey: string): FreshnessNotices {
  const [notices, setNotices] = useState<FreshnessNotices>({});
  useEffect(() => {
    if (!projectId) return;
    let live = true;
    const call = httpsCallable(functions, CLOUD_FUNCTIONS.GET_DOCUMENT_FRESHNESS, { timeout: CALLABLE_TIMEOUTS.SHORT });
    call({ projectId })
      .then((r) => {
        if (live) setNotices(((r.data as { notices?: FreshnessNotices } | null)?.notices) ?? {});
      })
      .catch((err) => console.warn('[freshness] notices not available:', err?.message ?? err));
    return () => {
      live = false;
    };
  }, [projectId, refreshKey]);
  return notices;
}
